import { render } from "./DxtPackageTopUp.vue?vue&type=template&id=b1d4c610&scoped=true"
import script from "./DxtPackageTopUp.vue?vue&type=script&lang=js"
export * from "./DxtPackageTopUp.vue?vue&type=script&lang=js"

import "./DxtPackageTopUp.vue?vue&type=style&index=0&id=b1d4c610&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b1d4c610"

export default script